import React, { useState } from 'react';
import '../assets/css/FAQ.css';

const faqs = [
  {
    q: "كم سيكلف ذلك؟",
    a: "للحصول على فكرة أفضل عن التكلفة، اتصل بنا عبر الهاتف. سنطرح عليك بعض الأسئلة حول طبيعة الموقع، ومستوى التفاعل المطلوب، واحتياجات التصميم، وغيرها. بعد ذلك، سنزودك بتقدير مبدئي. إذا كنت لا تزال مهتمًا، سنزور مقر عملك ونقدم لك عرضًا دقيقًا."
  },
  {
    q: "كم من الوقت يستغرق التصميم؟",
    a: "عادةً ما يتم تحديد مدة التنفيذ من قبل العميل. إذا كان لديك موعد محدد في ذهنك، فسنسعى جاهدين للالتزام به. أكثر الأسباب شيوعًا لتأخير المشروع هي انتظار استلام محتوى الصفحات من العميل."
  },
  {
    q: "كيف يمكنني التعاون مع شركة تكنولوجيا المعلومات؟",
    a: "تبدأ العملية عندما تتواصل معنا وتشاركنا متطلباتك. سنقوم بتحليلها والرد عليك. بناءً على النقاشات اللاحقة، يمكنك اختيار نموذج التعاون المناسب لك. بعد ذلك، نبدأ مرحلة التطوير."
  },
  {
    q: "هل يمكنكم تحسين مظهر موقعي الحالي؟",
    a: "نعم، بكل تأكيد. أخبرنا بمتطلباتك، وفريقنا ذو الخبرة سيساعدك على إعطاء موقعك مظهرًا احترافيًا جديدًا يثير الإعجاب!"
  },
  {
    q: "متى يجب علي الدفع؟",
    a: "بالنسبة لمعظم المشاريع، يتم الدفع على ثلاث دفعات متساوية: في البداية، في منتصف المشروع، وعند التسليم. ومع ذلك، يمكننا ترتيب جدول دفع يناسب احتياجاتك. نحن نتفهم أن هذه استثمار كبير، ونرغب بمساعدتك على تنظيم الميزانية بمرونة. نقبل الشيكات، PayPal، وجميع بطاقات الائتمان الرئيسية."
  },
];

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = index => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq" id="faq">
      <div className="faq-container">
        <h1 className="faq-title">الأسئلة الشائعة</h1>
        <div className="accordion-container">
          {faqs.map((item, index) => (
            // ! تعديل: أضفنا كلاس active هنا للتحكم بالأنيميشن
            <div className={`accordion ${activeIndex === index ? 'active' : ''}`} key={index}>
              <div className="accordion-header" onClick={() => toggle(index)}>
                <h3>{item.q}</h3>
                <span className="accordion-icon"></span>
              </div>
              {/* الإجابة موجودة دائمًا في الـ DOM لتطبيق الأنيميشن */}
              <div className="accordion-body">
                <p>{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;